import React from "react";
import "../styles/SkeletonCard.css";

export default function SkeletonCard()  {
  return (
    <div className="skeleton-card">
      <div className="skeleton-header"></div>
      <div className="skeleton-meta"></div>
      <div className="skeleton-desc"></div>
      <div className="skeleton-skills"></div>
      <div className="skeleton-footer"></div>
    </div>
  );
};


